export default "__VITE_ASSET__CWlccEJd__"